import { MapContainer, TileLayer, Marker, useMapEvents } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const TACOMA = [47.2529, -122.4443];

export const teardropHtml = (color = "#E76F51", emoji = "", imageUrl = "", size = 40) => `
  <div style="position:relative;width:${size}px;height:${Math.round(size * 1.15)}px;">
    <div style="position:absolute;top:0;left:0;width:${size}px;height:${size}px;background:${color};border-radius:50% 50% 50% 0;transform:rotate(-45deg);transform-origin:center;border:2px solid #fff;box-shadow:0 3px 10px rgba(0,0,0,0.4);display:flex;align-items:center;justify-content:center;">
      <div style="transform:rotate(45deg);font-size:${Math.round(size * 0.45)}px;line-height:1;">${
        imageUrl
          ? `<img src="${imageUrl}" style="width:${Math.round(size * 0.6)}px;height:${Math.round(size * 0.6)}px;border-radius:50%;object-fit:cover;display:block" alt=""/>`
          : (emoji || "")
      }</div>
    </div>
  </div>`;

export const teardropIcon = ({ color, emoji, image_url, size = 40 }) =>
  L.divIcon({
    className: "custom-teardrop-pin",
    html: teardropHtml(color, emoji, image_url, size),
    iconSize: [size, Math.round(size * 1.15)],
    iconAnchor: [size / 2, Math.round(size * 1.15)],
    popupAnchor: [0, -Math.round(size * 1.1)],
  });

const ClickPlacer = ({ onChange }) => {
  useMapEvents({ click: (e) => onChange(e.latlng.lat, e.latlng.lng) });
  return null;
};

// Mini-map with a draggable pin. Drag the pin (or tap the map) to set exact coords.
export const PinNudgeMap = ({ lat, lng, onChange, height = "260px", pinStyle }) => {
  const hasPos = lat != null && lng != null && !Number.isNaN(lat) && !Number.isNaN(lng);
  const pos = hasPos ? [Number(lat), Number(lng)] : TACOMA;
  const icon = pinStyle ? teardropIcon(pinStyle) : new L.Icon.Default();
  return (
    <div data-testid="pin-nudge-map">
      <div className="rounded-xl overflow-hidden border border-[#E2E0DC]" style={{ height }}>
        <MapContainer
          key={hasPos ? "set" : "unset"}
          center={pos}
          zoom={hasPos ? 16 : 11}
          scrollWheelZoom={false}
          style={{ height: "100%", width: "100%" }}
        >
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution='© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          />
          <ClickPlacer onChange={onChange} />
          <Marker
            position={pos}
            draggable
            icon={icon}
            eventHandlers={{
              dragend: (e) => {
                const p = e.target.getLatLng();
                onChange(p.lat, p.lng);
              },
            }}
          />
        </MapContainer>
      </div>
      <p className="text-[11px] text-[#5C5C5C] mt-1">
        Drag the pin (or tap the map) to the exact spot · {hasPos ? `${Number(lat).toFixed(6)}, ${Number(lng).toFixed(6)}` : "no location set — tap the map to place"}
      </p>
    </div>
  );
};

export default PinNudgeMap;
